import { render, staticRenderFns } from "./incentive-by-amount-form.vue?vue&type=template&id=1b922546"
import script from "./incentive-by-amount-form.vue?vue&type=script&lang=js"
export * from "./incentive-by-amount-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports